module.exports = __webpack_public_path__ + "static/media/Statua_042.0dd47209.jpg";